import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "mt10 align-right" }

import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { getSaaSStoreOrderDetailApi } from '@/apis/order'


export default /*@__PURE__*/_defineComponent({
  __name: 'SassSDetail',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute()
const id = route.query.id as string

const productList = ref<any>([])
const pickList = ref<any>([])

const closeOrder = () => {
    window.close()
}

const previewList = ref<any>([])

onMounted(async () => {
    const { code, data, msg } = await getSaaSStoreOrderDetailApi(id) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    productList.value = data.detail
    pickList.value = data.info
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: productList.value,
      border: "",
      style: {"width":"100%"},
      class: "mb20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "订单编号",
          prop: "order_code"
        }),
        _createVNode(_component_el_table_column, {
          label: "产品图片",
          prop: "product_image"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_image, {
              onClick: ($event: any) => (previewList.value = [row.product_image]),
              src: row.product_image,
              "preview-src-list": previewList.value,
              "preview-teleported": true
            }, null, 8, ["onClick", "src", "preview-src-list"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "产品名称",
          prop: "product_name"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品面值",
          prop: "amount"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品总价",
          prop: "total_amount"
        }),
        _createVNode(_component_el_table_column, {
          label: "购买数量",
          prop: "num"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品备注/规格",
          prop: "memo"
        }),
        _createVNode(_component_el_table_column, {
          label: "退款数量",
          prop: "refund_num"
        }),
        _createVNode(_component_el_table_column, {
          label: "退款面值",
          prop: "refund_amount"
        }),
        _createVNode(_component_el_table_column, {
          label: "下单时间",
          prop: "created_at"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_table, {
      data: pickList.value,
      border: "",
      style: {"width":"100%"},
      class: "mb20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "取餐码",
          prop: "takeInfo"
        }),
        _createVNode(_component_el_table_column, {
          label: "取餐二维码",
          prop: "qrData"
        }),
        _createVNode(_component_el_table_column, {
          label: "取餐柜",
          prop: "lockerCode"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, { onClick: closeOrder }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})